export enum ResponseMessageCode{
  Error = 0,
  Succeeded = 1,
  Validation = 2,
  PreApplyForServiceValidation = 3,
  Unauthorized = 4,
  ClosedTask = 5,
  FailedToLoadAfterSave = 6,
  UnvalidSavingRequest=7,
  Warning = 8
}
